<template>
  <div class="boss-approval-scrud">
    <div class="rpr-hero">
      <div class="rpr-hero__text">
        <span class="rpr-hero__kicker">Aprobación de Candidatos</span>
        <h1 class="rpr-hero__title">
          Gestiona candidatos en entrevista con jefe de área
        </h1>
        <p class="rpr-hero__subtitle">
          Apertura desde requerimientos aprobados y control de etapas.
        </p>
      </div>
      <div class="rpr-hero__badge">
        <span
          ><v-chip color="white" text-color="primary" large>
            <v-icon left small>mdi-account</v-icon>
            {{ filteredCandidates.length }} / {{ totalCandidates }} candidatos
          </v-chip>
        </span>
      </div>
    </div>
    <!-- <div > -->
    <!-- Header Hero -->
    <!-- <div class="approval-hero">
      <div class="hero-content">
        <v-icon size="40" color="white" class="mr-4">mdi-clipboard-check-multiple</v-icon>
        <div>
          <h1 class="hero-title">Aprobación de Candidatos</h1>
          <p class="hero-subtitle">Gestiona candidatos en entrevista con jefe de área</p>
        </div>
      </div>
      <v-chip color="white" text-color="primary" large>
        <v-icon left small>mdi-account</v-icon>
        {{ filteredCandidates.length }} / {{ totalCandidates }} candidatos
      </v-chip>
    </div> -->

    <!-- Main Container -->
    <v-container fluid class="pa-6">
      <!-- Toolbar -->
      <v-card class="mb-6 boss-toolbar-card" outlined>
        <v-card-text class="toolbar-section">
          <v-row align="center" justify="space-between" class="px-3">
            <v-col cols="12" md="7" class="d-flex flex-wrap gap-2">
              <v-row dense>
                <!-- <v-col cols="12" sm="4">
                  <v-select
                    v-model="selectedRprID"
                    :items="processOptions"
                    item-text="text"
                    item-value="value"
                    label="Proceso"
                    outlined
                    dense
                    clearable
                    hide-details
                  />
                </v-col> -->
                <!-- <v-col cols="12" sm="4">
                  <s-text
                    v-model="searchText"
                    label="Buscar candidato, DNI, proceso o req"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    clearable
                    hide-details
                  />
                </v-col> -->
                <v-col cols="12" sm="4">
                  <s-select
                    v-model="selectedPosition"
                    :items="positionOptions"
                    item-text="text"
                    item-value="value"
                    label="Puesto"
                    outlined
                    dense
                    clearable
                    hide-details
                  />
                </v-col>
                <!-- <v-col cols="12" sm="4">
                  <s-select
                    v-model="selectedStatus"
                    :items="statusOptions"
                    item-text="text"
                    item-value="value"
                    label="Estado"
                    outlined
                    dense
                    clearable
                    hide-details
                  />
                </v-col> -->
              </v-row>
            </v-col>
            <v-col
              cols="12"
              md="5"
              class="d-flex justify-md-end justify-start align-center flex-wrap"
            >
              <!-- <v-btn
                color="primary"
                class="mr-2 my-1"
                small
                :disabled="selectedForAgenda.length === 0"
                @click="openBulkAgendaDialog"
              >
                <v-icon left small>mdi-calendar-multiple</v-icon>
                Disponibilidad lote ({{ selectedForAgenda.length }})
              </v-btn> -->

              <v-btn
                color="primary"
                outlined
                small
                class="mr-2 my-1"
                :loading="loadingCandidates"
                @click="loadCandidates"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Recargar
              </v-btn>

              <!-- <v-btn
                color="success"
                small
                class="my-1"
                :loading="exporting"
                @click="exportToExcel"
              >
                <v-icon left small>mdi-file-excel</v-icon>
                Exportar Excel
              </v-btn> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Loading State -->
      <div v-if="loadingCandidates" class="text-center py-12">
        <v-progress-circular indeterminate color="primary" size="60" />
        <p class="mt-4 grey--text text-body2">
          Cargando candidatos en aprobación...
        </p>
      </div>

      <!-- Vista por carpetas -->
      <div
        v-if="!loadingCandidates && viewMode === 'folders'"
        class="folder-grid"
      >
        <v-card
          v-for="folder in recruitmentFolders"
          :key="folder.key"
          outlined
          class="folder-card"
          @click="openFolder(folder)"
        >
          <div class="folder-card__head">
            <div class="folder-card__icon">
              <v-icon color="primary">mdi-folder-open-outline</v-icon>
            </div>
            <div class="folder-card__title-wrap">
              <h3 class="folder-card__title">
                Proceso {{ folder.RprID }}
                <!-- · Req {{ folder.ReqID }} -->
              </h3>
              <p class="folder-card__subtitle">
                {{ folder.AppliedPosition }} · {{ folder.AreaName }}
              </p>
            </div>
            <v-chip small color="primary" text-color="white">{{
              folder.total
            }}</v-chip>
          </div>

          <div class="folder-card__stats">
            <div>
              <span>Activos</span>
              <strong>{{ folder.active }}</strong>
            </div>
            <div>
              <span>Rechazados</span>
              <strong>{{ folder.rejected }}</strong>
            </div>
            <div>
              <span>Seleccionados</span>
              <strong>{{ folder.selected }}</strong>
            </div>
          </div>

          <div class="folder-card__footer">
            <span>{{ folder.ResponsiblePosition || "Sin responsable" }}</span>
            <v-btn
              x-small
              text
              color="primary"
              @click.stop="openFolder(folder)"
            >
              Ver postulantes
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card>

        <v-card
          v-if="recruitmentFolders.length === 0"
          class="pa-6 text-center"
          outlined
        >
          <v-icon size="42" color="grey lighten-1" class="mb-2"
            >mdi-folder-search-outline</v-icon
          >
          <p class="grey--text text-body2 mb-0">
            No hay carpetas para los filtros aplicados
          </p>
        </v-card>
      </div>

      <!-- Data Table (vista lista) -->
      <v-card v-if="!loadingCandidates && viewMode === 'list'" outlined>
        <v-data-table
          v-model="selectedForAgenda"
          :headers="headers"
          :items="filteredCandidates"
          class="elevation-0"
          dense
          show-select
          item-key="CprID"
          @pagination="onPaginationChanged"
        >
          <template v-slot:[`item.CurrentStageName`]="{ item }">
            <v-chip
              x-small
              :color="stageColor(item.CurrentStageID)"
              text-color="white"
            >
              {{ item.CurrentStageName || "-" }}
            </v-chip>
          </template>

          <template v-slot:[`item.CprStatusName`]="{ item }">
            <v-chip
              x-small
              :color="statusColor(item.CprStatus)"
              text-color="white"
            >
              {{ item.CprStatusName || "-" }}
            </v-chip>
          </template>

          <template v-slot:[`item.cv`]="{ item }">
            <v-btn
              x-small
              text
              color="primary"
              :disabled="!item.FileKeyCV"
              @click="openCVPreview(item)"
            >
              <v-icon small>mdi-file-eye-outline</v-icon>
            </v-btn>
          </template>

          <!-- Actions Column -->
          <template v-slot:[`item.actions`]="{ item }">
            <div v-if="isOwnerOrAdmin(item)" class="action-buttons">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    :color="hasAgenda(item) ? 'success' : 'primary'"
                    text
                    :disabled="
                      !canOperateCandidate(item) ||
                      (hasAgenda(item) &&
                        (!hasScheduledInterview(item) ||
                          !hasInterviewFinished(item)))
                    "
                    :loading="
                      approvingCprID === item.CprID ||
                      savingAgendaCprID === item.CprID
                    "
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      hasAgenda(item)
                        ? approveCandidate(item)
                        : openAgendaDialog(item)
                    "
                  >
                    <v-icon small>{{ primaryActionIcon(item) }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ primaryActionLabel(item) }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    color="error"
                    text
                    :disabled="!canOperateCandidate(item)"
                    :loading="rejectingCprID === item.CprID"
                    v-bind="attrs"
                    v-on="on"
                    @click="openRejectDialog(item)"
                  >
                    <v-icon small>mdi-close-circle</v-icon>
                  </v-btn>
                </template>
                <span>Rechazar candidato</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Empty State -->
          <template v-slot:no-data>
            <div class="pa-6 text-center">
              <v-icon size="48" color="grey" class="mb-3"
                >mdi-inbox-multiple</v-icon
              >
              <p class="grey--text text-body2">
                No hay candidatos en aprobación
              </p>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <!-- Modal de carpeta -->
    <v-dialog v-model="folderDialog" max-width="1500" persistent>
      <v-card>
        <v-card-title class="folder-modal__title">
          <div>
            <h3 class="mb-1">
              Proceso {{ activeFolderMeta?.RprID || "-" }}
              <!-- · Req {{ activeFolderMeta?.ReqID || '-' }} -->
            </h3>
            <p class="mb-0 grey--text text--darken-1">
              {{ activeFolderMeta?.AppliedPosition || "-" }} ·
              {{ activeFolderMeta?.AreaName || "-" }}
            </p>
          </div>
          <v-spacer />
          <v-btn
                color="primary"
                class="mr-2 my-1"
                small
                :disabled="selectedForAgenda.length === 0"
                @click="openBulkAgendaDialog"
              >
                <v-icon left small>mdi-calendar-multiple</v-icon>
                Disponibilidad lote ({{ selectedForAgenda.length }})
              </v-btn>
              <v-btn
                color="success"
                small
                class="my-1"
                :loading="exporting"
                @click="exportToExcel"
              >
                <v-icon left small>mdi-file-excel</v-icon>
                Exportar Excel
              </v-btn>
          <v-chip small color="primary" text-color="white" class="mr-2">
            {{ activeFolderCandidates.length }} postulantes
          </v-chip>
          <v-btn icon @click="closeFolder">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-data-table
            v-model="selectedForAgenda"
            :headers="headers"
            :items="activeFolderCandidates"
            dense
            show-select
            item-key="CprID"
            @pagination="onPaginationChanged"
          >
            <template v-slot:[`item.CurrentStageName`]="{ item }">
              <v-chip
                x-small
                :color="stageColor(item.CurrentStageID)"
                text-color="white"
              >
                {{ item.CurrentStageName || "-" }}
              </v-chip>
            </template>

            <template v-slot:[`item.CprStatusName`]="{ item }">
              <v-chip
                x-small
                :color="statusColor(item.CprStatus)"
                text-color="white"
              >
                {{ item.CprStatusName || "-" }}
              </v-chip>
            </template>

            <template v-slot:[`item.cv`]="{ item }">
              <v-btn
                x-small
                text
                color="primary"
                :disabled="!item.FileKeyCV"
                @click="openCVPreview(item)"
              >
                <v-icon small>mdi-file-eye-outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div v-if="isOwnerOrAdmin(item)" class="action-buttons">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      :color="hasAgenda(item) ? 'success' : 'primary'"
                      text
                      :disabled="
                        !canOperateCandidate(item) ||
                        (hasAgenda(item) &&
                          (!hasScheduledInterview(item) ||
                            !hasInterviewFinished(item)))
                      "
                      :loading="
                        approvingCprID === item.CprID ||
                        savingAgendaCprID === item.CprID
                      "
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        hasAgenda(item)
                          ? approveCandidate(item)
                          : openAgendaDialog(item)
                      "
                    >
                      <v-icon small>{{ primaryActionIcon(item) }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ primaryActionLabel(item) }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      color="error"
                      text
                      :disabled="!canOperateCandidate(item)"
                      :loading="rejectingCprID === item.CprID"
                      v-bind="attrs"
                      v-on="on"
                      @click="openRejectDialog(item)"
                    >
                      <v-icon small>mdi-close-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Rechazar candidato</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeFolder">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Rejection Dialog -->
    <v-dialog v-model="rejectDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="bg-red-100">
          <v-icon color="error" large left>mdi-close-circle</v-icon>
          Rechazar Candidato
        </v-card-title>

        <v-card-text class="pt-5">
          <p v-if="selectedCandidate" class="mb-4">
            ¿Rechazar a <strong>{{ selectedCandidate.CandidateName }}</strong
            >?
          </p>
          <v-textarea
            v-model="rejectObservation"
            label="Observación *"
            outlined
            rows="4"
            counter="500"
            maxlength="500"
            placeholder="Ingresa el motivo del rechazo..."
            :rules="[(v) => !!v || 'Campo obligatorio']"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="rejectDialog = false">Cancelar</v-btn>
          <v-btn
            color="error"
            :loading="rejectingCprID === selectedCandidate?.CprID"
            :disabled="!rejectObservation.trim()"
            @click="confirmReject"
          >
            Rechazar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Agenda Dialog (Paso 1) -->
    <v-dialog v-model="agendaDialog" max-width="640" persistent>
      <v-card>
        <v-card-title> Registrar Agenda de Entrevista </v-card-title>

        <v-card-text class="pt-5">
          <p
            v-if="agendaDialogMode === 'single' && agendaCandidate"
            class="mb-4"
          >
            Candidato:
            <strong>{{ getCandidateDisplayName(agendaCandidate) }}</strong>
          </p>
          <div v-else class="mb-4">
            <p class="mb-1">
              Candidatos seleccionados:
              <strong>{{ agendaTargets.length }}</strong>
            </p>
            <p
              class="mb-0 grey--text text--darken-1"
              v-if="agendaTargets.length"
            >
              {{ agendaTargetsPreview }}
            </p>
          </div>

          <v-row>
            <v-col cols="12" md="6">
              <s-select
                v-model="agendaForm.modality"
                :items="modalityOptions"
                item-text="text"
                item-value="value"
                label="Modalidad *"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="6">
              <s-text
                v-if="agendaForm.modality === 'presencial'"
                v-model="agendaForm.location"
                label="Ubicación presencial *"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <div class="mb-3">
            <div class="d-flex align-center justify-space-between mb-2">
              <strong>Disponibilidad por fecha y rangos *</strong>
              <v-btn x-small color="primary" text @click="addAvailabilitySlot">
                <v-icon left small>mdi-plus</v-icon>
                Agregar fecha
              </v-btn>
            </div>

            <v-row
              v-for="(slot, idx) in agendaForm.availabilitySlots"
              :key="`slot-${idx}`"
              class="mb-2"
            >
              <v-col cols="12" md="3">
                <s-text
                  v-model="slot.date"
                  type="date"
                  :label="`Fecha ${idx + 1} *`"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="8">
                <div
        v-for="(interval, intIdx) in slot.intervals"
        :key="`slot-${idx}-int-${intIdx}`"
        class="d-flex align-center mb-3"
      >
        <div style="width: 140px;" class="mr-2">
          <s-text
            v-model="interval.start"
            type="time"
            label="Inicio *"
            outlined
            dense
            hide-details
          />
        </div>

        <div style="width: 140px;" class="mr-2">
          <s-text
            v-model="interval.end"
            type="time"
            label="Fin *"
            outlined
            dense
            hide-details
          />
        </div>

        <v-btn
          icon
          small
          color="error"
          class="flex-shrink-0"
          :disabled="slot.intervals.length === 1"
          @click="removeInterval(idx, intIdx)"
        >
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </div>

                <v-btn x-small text color="primary" @click="addInterval(idx)">
                  <v-icon left small>mdi-plus</v-icon>
                  Agregar intervalo
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                md="1"
                class="d-flex align-center justify-center"
              >
                <v-btn
                  icon
                  x-small
                  color="error"
                  @click="removeAvailabilitySlot(idx)"
                >
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-alert
              v-if="availabilityPreviewRows.length"
              dense
              text
              type="info"
              class="mt-2"
            >
              <div
                v-for="(line, lineIdx) in availabilityPreviewRows"
                :key="`availability-preview-${lineIdx}`"
                class="availability-preview-line"
              >
                {{ line }}
              </div>
            </v-alert>
          </div>

          <v-textarea
            v-model="agendaForm.notes"
            label="Observación"
            outlined
            rows="3"
            counter="500"
            maxlength="500"
            placeholder="Rango referencial para que RRHH coordine la entrevista"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="agendaDialog = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="savingAgendaCprID === agendaCandidate?.CprID"
            @click="saveAgenda"
          >
            Guardar Agenda
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Preview CV -->
    <v-dialog v-model="previewDialog" max-width="900px">
      <v-card>
        <v-card-title>
          Vista previa CV
          <v-spacer />
          <v-btn icon @click="closePreview">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="min-height: 450px">
          <iframe
            v-if="previewType === 'pdf' && previewUrl"
            :src="previewUrl"
            width="100%"
            height="500"
            style="border: 0"
          />
          <img
            v-else-if="previewType === 'image' && previewUrl"
            :src="previewUrl"
            alt="preview"
            style="max-width: 100%; max-height: 500px"
          />
          <div v-else class="text-center py-10">
            No se puede previsualizar este archivo.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="downloadCurrentCV">Descargar</v-btn>
          <v-btn color="primary" text @click="closePreview">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmation Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" top right>
      <v-icon left small>{{ snackbarIcon }}</v-icon>
      {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import HmnCandidateProcessService from "@/services/HumanResource/RecruitmentProcess/HmnCandidateProcessService";
import GenUploadFiles from "@/services/General/GenUploadFiles";
import { exportVuetifyToExcel } from "@/utils/excelExport";

export default {
  name: "HmnBossApprovalSCRUD",
  data() {
    return {
      // Main Data
      candidates: [],
      searchText: "",
      selectedRprID: null,
      selectedPosition: null,
      selectedStatus: null,
      viewMode: "folders",
      loadingCandidates: false,
      exporting: false,

      // Pagination
      currentPage: 1,
      itemsPerPage: 10,
      totalCandidates: 0,

      // States
      approvingCprID: null,
      rejectingCprID: null,
      savingAgendaCprID: null,
      agendaRegistered: {},
      interviewScheduleMap: {},
      rejectDialog: false,
      selectedCandidate: null,
      rejectObservation: "",
      selectedForAgenda: [],
      folderDialog: false,
      activeFolderKey: null,
      agendaDialog: false,
      agendaDialogMode: "single",
      agendaCandidate: null,
      agendaTargets: [],
      agendaForm: {
        modality: "remoto",
        availabilitySlots: [
          {
            date: "",
            intervals: [{ start: "", end: "" }],
          },
        ],
        location: "",
        notes: "",
      },
      modalityOptions: [
        { text: "Remoto", value: "remoto" },
        { text: "Presencial", value: "presencial" },
      ],

      // CV Preview
      previewDialog: false,
      previewUrl: null,
      previewType: null,
      currentPreviewFile: null,

      // Feedback
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
      snackbarIcon: "mdi-check-circle",

      // Headers for data table
      headers: this.$fun.isAdmin()
        ? [
            // { text: "N°", value: "RowNum", width: "50px", sortable: false },
            { text: "DNI", value: "PrsDocumentNumber", width: "100px" },
            { text: "Candidato", value: "CandidateName", width: "200px" },
            { text: "Puesto", value: "AppliedPosition", width: "180px" },
            { text: "Proceso", value: "RprID", width: "90px" },
            { text: "Área", value: "AreaName", width: "140px" },
            { text: "Etapa", value: "CurrentStageName", width: "150px" },
            { text: "Estado", value: "CprStatusName", width: "120px" },
            // { text: "Responsable Área", value: "ResponsiblePosition", width: "180px" },
            { text: "Edad", value: "Age", width: "80px" },
            // { text: "Residencia Actual", value: "CurrentResidence" },
            // { text: "Cambio Residencia", value: "ChangeResidence" },
            // { text: "Disponibilidad", value: "Availability" },
            // { text: "Trabaja Actualmente", value: "Working" },
            // { text: "Empresas Resaltantes", value: "ProminentCompanies" },
            // { text: "Experiencia", value: "Experience" },
            // { text: "Contacto Referencias", value: "ReferenceContact" },
            // { text: "Perfil Profesional", value: "ProfessionalProfile" },
            // { text: "Criterios Indispensables", value: "EssentialCriterion" },
            // { text: "Descripción Experiencia", value: "ExperienceDescription" },
            // { text: "Salario Actual", value: "CurrentSalary", align: "right" },
            // { text: "Pretensión Salarial", value: "SalaryExpectation", align: "right" },
            {
              text: "CV",
              value: "cv",
              width: "90px",
              sortable: false,
              align: "center",
            },
            //{ text: "Conformidad Condiciones", value: "ConformidadCondiciones" },
            {
              text: "Acciones",
              value: "actions",
              width: "120px",
              sortable: false,
              align: "center",
            },
          ]
        : [
            // { text: "N°", value: "RowNum", width: "50px", sortable: false },
            { text: "DNI", value: "PrsDocumentNumber", width: "100px" },
            { text: "Candidato", value: "CandidateName", width: "200px" },
            // { text: "Puesto", value: "AppliedPosition", width: "180px" },
            // { text: "Proceso", value: "RprID", width: "90px" },
            // { text: "Área", value: "AreaName", width: "140px" },
            // { text: "Etapa", value: "CurrentStageName", width: "150px" },
            // { text: "Estado", value: "CprStatusName", width: "120px" },
            // { text: "Responsable Área", value: "ResponsiblePosition", width: "180px" },
            { text: "Edad", value: "Age", width: "80px" },
            // { text: "Residencia Actual", value: "CurrentResidence" },
            // { text: "Cambio Residencia", value: "ChangeResidence" },
            // { text: "Disponibilidad", value: "Availability" },
            // { text: "Trabaja Actualmente", value: "Working" },
            // { text: "Empresas Resaltantes", value: "ProminentCompanies" },
            // { text: "Experiencia", value: "Experience" },
            // { text: "Contacto Referencias", value: "ReferenceContact" },
            // { text: "Perfil Profesional", value: "ProfessionalProfile" },
            // { text: "Criterios Indispensables", value: "EssentialCriterion" },
            // { text: "Descripción Experiencia", value: "ExperienceDescription" },
            {
              text: "CV",
              value: "cv",
              width: "90px",
              sortable: false,
              align: "center",
            },
            //{ text: "Conformidad Condiciones", value: "ConformidadCondiciones" },
            {
              text: "Acciones",
              value: "actions",
              width: "120px",
              sortable: false,
              align: "center",
            },
          ],
      headersExcel: this.$fun.isAdmin()
        ? [
            // { text: "N°", value: "RowNum", width: "50px", sortable: false },
            { text: "DNI", value: "PrsDocumentNumber", width: "100px" },
            { text: "Candidato", value: "CandidateName", width: "200px" },
            { text: "Puesto", value: "AppliedPosition", width: "180px" },
            { text: "Área", value: "AreaName", width: "140px" },
            // { text: "Responsable Área", value: "ResponsiblePosition", width: "180px" },
            { text: "Edad", value: "Age", width: "80px" },
            { text: "Residencia Actual", value: "CurrentResidence" },
            { text: "Cambio Residencia", value: "ChangeResidence" },
            { text: "Disponibilidad", value: "Availability" },
            { text: "Trabaja Actualmente", value: "Working" },
            { text: "Empresas Resaltantes", value: "ProminentCompanies" },
            { text: "Experiencia", value: "Experience" },
            { text: "Contacto Referencias", value: "ReferenceContact" },
            { text: "Perfil Profesional", value: "ProfessionalProfile" },
            { text: "Criterios Indispensables", value: "EssentialCriterion" },
            { text: "Descripción Experiencia", value: "ExperienceDescription" },
            { text: "Salario Actual", value: "CurrentSalary", align: "right" },
            {
              text: "Pretensión Salarial",
              value: "SalaryExpectation",
              align: "right",
            },
            // { text: "CV", value: "cv", width: "90px", sortable: false, align: "center" },
            //{ text: "Conformidad Condiciones", value: "ConformidadCondiciones" },
            // { text: "Acciones", value: "actions", width: "120px", sortable: false, align: "center" },
          ]
        : [
            // { text: "N°", value: "RowNum", width: "50px", sortable: false },
            { text: "DNI", value: "PrsDocumentNumber", width: "100px" },
            { text: "Candidato", value: "CandidateName", width: "200px" },
            { text: "Puesto", value: "AppliedPosition", width: "180px" },
            { text: "Área", value: "AreaName", width: "140px" },
            // { text: "Responsable Área", value: "ResponsiblePosition", width: "180px" },
            { text: "Edad", value: "Age", width: "80px" },
            { text: "Residencia Actual", value: "CurrentResidence" },
            { text: "Cambio Residencia", value: "ChangeResidence" },
            { text: "Disponibilidad", value: "Availability" },
            { text: "Trabaja Actualmente", value: "Working" },
            { text: "Empresas Resaltantes", value: "ProminentCompanies" },
            { text: "Experiencia", value: "Experience" },
            { text: "Contacto Referencias", value: "ReferenceContact" },
            { text: "Perfil Profesional", value: "ProfessionalProfile" },
            { text: "Criterios Indispensables", value: "EssentialCriterion" },
            { text: "Descripción Experiencia", value: "ExperienceDescription" },
            // { text: "CV", value: "cv", width: "90px", sortable: false, align: "center" },
            //{ text: "Conformidad Condiciones", value: "ConformidadCondiciones" },
            // { text: "Acciones", value: "actions", width: "120px", sortable: false, align: "center" },
          ],
    };
  },

  computed: {
    processOptions() {
      const unique = [
        ...new Set(this.candidates.map((c) => c.RprID).filter((v) => !!v)),
      ];
      return unique
        .sort((a, b) => Number(b) - Number(a))
        .map((value) => ({ value, text: `Proceso ${value}` }));
    },
    positionOptions() {
      const unique = [
        ...new Set(
          this.candidates.map((c) => c.AppliedPosition).filter((v) => !!v),
        ),
      ];
      return unique
        .sort((a, b) => String(a).localeCompare(String(b)))
        .map((value) => ({ value, text: value }));
    },
    statusOptions() {
      return [
        { value: 1, text: "Activo" },
        { value: 0, text: "Rechazado" },
        { value: 2, text: "Seleccionado" },
      ];
    },
    filteredCandidates() {
      return this.candidates.filter((candidate) => {
        const searchValue = String(this.searchText || "")
          .trim()
          .toLowerCase();
        if (searchValue) {
          const haystack = [
            candidate?.CandidateName,
            candidate?.PrsDocumentNumber,
            candidate?.AppliedPosition,
            candidate?.AreaName,
            candidate?.RprID,
            candidate?.ReqID,
          ]
            .filter((value) => value !== null && value !== undefined)
            .map((value) => String(value).toLowerCase())
            .join(" ");

          if (!haystack.includes(searchValue)) {
            return false;
          }
        }

        if (
          this.selectedRprID &&
          Number(candidate.RprID) !== Number(this.selectedRprID)
        ) {
          return false;
        }

        if (
          this.selectedPosition &&
          candidate.AppliedPosition !== this.selectedPosition
        ) {
          return false;
        }

        if (this.selectedStatus !== null && this.selectedStatus !== undefined) {
          if (Number(candidate.CprStatus) !== Number(this.selectedStatus)) {
            return false;
          }
        }

        return true;
      });
    },
    recruitmentFolders() {
      const grouped = this.filteredCandidates.reduce((acc, candidate) => {
        const rprID = Number(candidate?.RprID || 0);
        const reqID = Number(candidate?.ReqID || 0);

        const key = `${rprID}::${reqID}`;

        if (!acc[key]) {
          acc[key] = {
            key,
            RprID: rprID,
            ReqID: reqID,
            AppliedPosition: candidate?.AppliedPosition || "Sin puesto",
            AreaName: candidate?.AreaName || "Sin área",
            ResponsiblePosition: candidate?.ResponsiblePosition || "",
            total: 0,
            active: 0,
            rejected: 0,
            selected: 0,
          };
        }

        acc[key].total += 1;
        if (Number(candidate?.CprStatus) === 1) acc[key].active += 1;
        if (Number(candidate?.CprStatus) === 0) acc[key].rejected += 1;
        if (Number(candidate?.CprStatus) === 2) acc[key].selected += 1;

        return acc;
      }, {});

      return Object.values(grouped).sort((a, b) => {
        if (Number(b.RprID) !== Number(a.RprID)) {
          return Number(b.RprID) - Number(a.RprID);
        }
        return Number(b.ReqID) - Number(a.ReqID);
      });
    },
    activeFolderMeta() {
      if (!this.activeFolderKey) return null;
      return (
        this.recruitmentFolders.find(
          (folder) => folder.key === this.activeFolderKey,
        ) || null
      );
    },
    activeFolderCandidates() {
      if (!this.activeFolderKey) return [];
      return this.filteredCandidates.filter(
        (candidate) =>
          this.folderKeyForCandidate(candidate) === this.activeFolderKey
          //solo seleccionar candidadtos activos para la agenda
           && Number(candidate.CprStatus) === 1
      );
    },
    agendaTargetsPreview() {
      if (!this.agendaTargets.length) return "";
      const preview = this.agendaTargets
        .slice(0, 3)
        .map((candidate) => this.getCandidateDisplayName(candidate));
      if (this.agendaTargets.length > 3) {
        preview.push(`+${this.agendaTargets.length - 3} más`);
      }
      return preview.join(", ");
    },
    availabilityPreviewRows() {
      try {
        const slots = this.normalizeAgendaAvailabilitySlots({
          throwOnError: false,
        });
        return slots.map((slot) => {
          const dateLabel = this.formatAvailabilityDateLabel(slot.date);
          const rangesLabel = slot.ranges
            .map((range) => `${range.start}-${range.end}`)
            .join(" | ");
          return `${dateLabel} | ${rangesLabel}`;
        });
      } catch (_) {
        return [];
      }
    },
  },

  mounted() {
    this.loadCandidates();
  },

  methods: {
    getInterviewExportColumns(rows) {
      return Object.keys(rows?.[0] || {}).map((key) => ({
        value: key,
        text: key,
      }));
    },
    mapInterviewRowsForExport(rows, columns) {
      return rows.map((row) => {
        const exportRow = {};

        columns.forEach((column) => {
          const headerText = String(column.text || column.value || "").trim();
          if (!headerText) return;
          exportRow[headerText] = row[column.value];
        });

        return exportRow;
      });
    },
    folderKeyForCandidate(candidate) {
      const rprID = Number(candidate?.RprID || 0);
      const reqID = Number(candidate?.ReqID || 0);
      return `${rprID}::${reqID}`;
    },
    openFolder(folder) {
      if (!folder?.key) return;
      this.activeFolderKey = folder.key;
      this.folderDialog = true;
    },
    closeFolder() {
      this.folderDialog = false;
      this.activeFolderKey = null;
    },
    getCandidateDisplayName(item) {
      return item?.CandidateName || item?.FullName || "Candidato";
    },
    hasAgenda(item) {
      return !!this.agendaRegistered[item?.CprID];
    },
    hasScheduledInterview(item) {
      return !!this.interviewScheduleMap[item?.CprID];
    },
    hasInterviewFinished(item) {
      const schedule = this.interviewScheduleMap[item?.CprID];
      if (!schedule?.endDateTime) return false;
      const endDate = new Date(schedule.endDateTime);
      if (Number.isNaN(endDate.getTime())) return false;
      return endDate.getTime() <= Date.now();
    },
    primaryActionIcon(item) {
      if (!this.hasAgenda(item)) return "mdi-calendar-plus";
      if (!this.hasScheduledInterview(item)) return "mdi-calendar-clock";
      if (!this.hasInterviewFinished(item)) return "mdi-timer-sand";
      return "mdi-check-circle";
    },
    primaryActionLabel(item) {
      if (!this.hasAgenda(item)) {
        return "Registrar disponibilidad (cliente interno)";
      }
      if (!this.hasScheduledInterview(item)) {
        return "Esperando agenda de reunión en Reclutamiento";
      }
      if (!this.hasInterviewFinished(item)) {
        return "La segunda aceptación se habilita al terminar la entrevista";
      }
      return "Dar segunda aceptación y avanzar";
    },
    parseStructuredObservation(observation, prefix) {
      const text = String(observation || "").trim();
      if (!text.startsWith(`${prefix}|`)) return null;

      const payload = text.substring(prefix.length + 1);
      const result = {};
      payload.split("|").forEach((segment) => {
        const separatorIndex = segment.indexOf("=");
        if (separatorIndex <= 0) return;
        const key = segment.substring(0, separatorIndex).trim();
        const value = segment.substring(separatorIndex + 1).trim();
        if (!key) return;
        result[key] = value;
      });

      return result;
    },
    toTimestamp(value) {
      if (!value) return null;
      const parsed = new Date(String(value).trim());
      if (Number.isNaN(parsed.getTime())) return null;
      return parsed.getTime();
    },
    resolveApprovalFlowFromHistory(history) {
      const entries = Array.isArray(history) ? history : [];

      let latestAgendaAt = null;
      entries.forEach((entry) => {
        const observation = String(entry?.Observation || "");
        if (!observation.startsWith("AGENDA_INTERNA|")) return;
        const actionMs = this.toTimestamp(
          entry?.ActionDate || entry?.SecCreate,
        );
        if (actionMs === null) return;
        if (latestAgendaAt === null || actionMs > latestAgendaAt) {
          latestAgendaAt = actionMs;
        }
      });

      const latestMeeting = entries
        .map((entry) => {
          const payload = this.parseStructuredObservation(
            entry?.Observation,
            "REUNION_INTERNA",
          );
          if (!payload?.FIN) return null;

          const actionMs = this.toTimestamp(
            entry?.ActionDate || entry?.SecCreate,
          );
          const endMs = this.toTimestamp(payload.FIN);
          if (actionMs === null || endMs === null) return null;

          return {
            actionMs,
            endMs,
            data: {
              modality: payload.MODALIDAD || "",
              startDateTime: payload.INICIO || "",
              endDateTime: payload.FIN || "",
              location: payload.UBICACION || "",
              meetingLink: payload.ENLACE || "",
            },
          };
        })
        .filter((entry) => {
          if (!entry) return false;
          if (latestAgendaAt === null) return true;
          return entry.actionMs >= latestAgendaAt;
        })
        .sort((a, b) => b.actionMs - a.actionMs)[0];

      return {
        hasAgenda: latestAgendaAt !== null,
        meeting: latestMeeting?.data || null,
      };
    },
    resetAgendaForm() {
      this.agendaForm = {
        modality: "remoto",
        availabilitySlots: [
          {
            date: "",
            intervals: [{ start: "", end: "" }],
          },
        ],
        location: "",
        notes: "",
      };
    },
    addAvailabilitySlot() {
      this.agendaForm.availabilitySlots.push({
        date: "",
        intervals: [{ start: "", end: "" }],
      });
    },
    removeAvailabilitySlot(index) {
      if (this.agendaForm.availabilitySlots.length === 1) {
        this.agendaForm.availabilitySlots = [
          {
            date: "",
            intervals: [{ start: "", end: "" }],
          },
        ];
        return;
      }
      this.agendaForm.availabilitySlots.splice(index, 1);
    },
    addInterval(slotIndex) {
      const slot = this.agendaForm.availabilitySlots?.[slotIndex];
      if (!slot) return;
      if (!Array.isArray(slot.intervals)) {
        this.$set(slot, "intervals", []);
      }
      slot.intervals.push({ start: "", end: "" });
    },
    removeInterval(slotIndex, intervalIndex) {
      const slot = this.agendaForm.availabilitySlots?.[slotIndex];
      if (!slot) return;
      if (!Array.isArray(slot.intervals) || slot.intervals.length <= 1) {
        this.$set(slot, "intervals", [{ start: "", end: "" }]);
        return;
      }
      slot.intervals.splice(intervalIndex, 1);
    },
    formatAvailabilityDateLabel(dateValue) {
      const date = new Date(`${dateValue}T00:00:00`);
      if (Number.isNaN(date.getTime())) return dateValue;

      const dayMap = ["DOM", "LUN", "MAR", "MIE", "JUE", "VIE", "SAB"];
      const day = dayMap[date.getDay()] || "";
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = String(date.getFullYear());

      return `${day} ${dd}/${mm}/${yyyy}`;
    },
    normalizeAgendaAvailabilitySlots(options = {}) {
      const { throwOnError = true } = options;
      const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
      const rawSlots = Array.isArray(this.agendaForm.availabilitySlots)
        ? this.agendaForm.availabilitySlots
        : [];

      try {
        const slots = rawSlots
          .map((slot) => {
            const date = String(slot?.date || "").trim();
            const rawIntervals = Array.isArray(slot?.intervals)
              ? slot.intervals
              : [];

            if (!date || !rawIntervals.length) return null;

            const ranges = rawIntervals
              .map((interval) => ({
                start: String(interval?.start || "").trim(),
                end: String(interval?.end || "").trim(),
              }))
              .filter((interval) => interval.start || interval.end)
              .map((interval) => {
                if (
                  !timeRegex.test(interval.start) ||
                  !timeRegex.test(interval.end) ||
                  interval.start >= interval.end
                ) {
                  throw new Error(
                    `Intervalo inválido (${interval.start}-${interval.end}) para ${date}. La hora inicio debe ser menor a fin.`,
                  );
                }
                return interval;
              })
              .sort((a, b) => a.start.localeCompare(b.start));

            if (!ranges.length) return null;

            for (let i = 1; i < ranges.length; i += 1) {
              if (ranges[i].start < ranges[i - 1].end) {
                throw new Error(
                  `Hay intervalos solapados en ${date}. Ajusta los rangos para que no se crucen.`,
                );
              }
            }

            return { date, ranges };
          })
          .filter((slot) => !!slot)
          .sort((a, b) => String(a.date).localeCompare(String(b.date)));

        if (!slots.length) {
          if (throwOnError) {
            throw new Error(
              "Debes ingresar al menos una fecha con uno o más intervalos horarios",
            );
          }
          return [];
        }

        return slots;
      } catch (error) {
        if (throwOnError) throw error;
        return [];
      }
    },
    buildAgendaObservation() {
      const mode =
        this.agendaForm.modality === "presencial" ? "PRESENCIAL" : "REMOTO";
      const location =
        this.agendaForm.modality === "presencial"
          ? this.agendaForm.location
          : "N/A";
      const notes = (this.agendaForm.notes || "").replace(/\|/g, "/");
      const availabilitySlots = this.normalizeAgendaAvailabilitySlots();
      const firstSlot = availabilitySlots[0];
      const lastSlot = availabilitySlots[availabilitySlots.length - 1];
      const firstRange = firstSlot.ranges[0];
      const encodedAvailability = encodeURIComponent(
        JSON.stringify(availabilitySlots),
      );

      return [
        "AGENDA_INTERNA",
        `MODALIDAD=${mode}`,
        `DESDE=${firstSlot.date}`,
        `HASTA=${lastSlot.date}`,
        `HORA_DESDE=${firstRange.start}`,
        `HORA_HASTA=${firstRange.end}`,
        `DISPONIBILIDAD_JSON=${encodedAvailability}`,
        `UBICACION=${location}`,
        `OBS=${notes}`,
      ].join("|");
    },
    validateAgendaForm() {
      try {
        this.normalizeAgendaAvailabilitySlots();
      } catch (error) {
        this.$fun.alert(error?.message || "Disponibilidad inválida", "warning");
        return false;
      }
      if (
        this.agendaForm.modality === "presencial" &&
        !String(this.agendaForm.location || "").trim()
      ) {
        this.$fun.alert("Debes ingresar ubicación para presencial", "warning");
        return false;
      }
      return true;
    },
    openAgendaDialog(candidate) {
      if (!candidate) return;
      this.agendaDialogMode = "single";
      this.agendaCandidate = candidate;
      this.agendaTargets = [candidate];
      this.resetAgendaForm();
      this.agendaDialog = true;
    },
    openBulkAgendaDialog() {
      const selected = this.selectedForAgenda.filter(
        (candidate) =>
          this.canOperateCandidate(candidate) && !this.hasAgenda(candidate),
      );

      if (!selected.length) {
        this.showSnackbar(
          "Selecciona candidatos activos de etapa 5 sin disponibilidad registrada",
          "warning",
          "mdi-alert",
        );
        return;
      }

      this.agendaDialogMode = "bulk";
      this.agendaCandidate = null;
      this.agendaTargets = selected;
      this.resetAgendaForm();
      this.agendaDialog = true;
    },
    async saveAgenda() {
      if (!this.validateAgendaForm()) return;

      const targets =
        this.agendaDialogMode === "bulk"
          ? this.agendaTargets.filter(
              (candidate) =>
                this.canOperateCandidate(candidate) &&
                !this.hasAgenda(candidate),
            )
          : this.agendaCandidate
          ? [this.agendaCandidate]
          : [];

      if (!targets.length) {
        this.showSnackbar(
          "No hay candidatos válidos para registrar disponibilidad",
          "warning",
          "mdi-alert",
        );
        return;
      }

      const observation = this.buildAgendaObservation();
      this.savingAgendaCprID = targets[0].CprID;

      try {
        await Promise.all(
          targets.map((candidate) =>
            HmnCandidateProcessService.updateStatus(
              candidate.CprID,
              1,
              observation,
              this.$fun.getUserID(),
            ),
          ),
        );

        targets.forEach((candidate) => {
          this.$set(this.agendaRegistered, candidate.CprID, true);
        });

        this.agendaDialog = false;
        this.agendaDialogMode = "single";
        this.agendaCandidate = null;
        this.agendaTargets = [];
        this.selectedForAgenda = this.selectedForAgenda.filter(
          (candidate) =>
            !targets.some((target) => target.CprID === candidate.CprID),
        );
        this.showSnackbar(
          `Disponibilidad registrada para ${targets.length} candidato(s)`,
          "success",
          "mdi-calendar-check",
        );
      } catch (error) {
        this.showSnackbar(
          error?.response?.data?.Message || "Error al registrar agenda",
          "error",
          "mdi-alert-circle",
        );
      } finally {
        this.savingAgendaCprID = null;
      }
    },
    normalizeCandidateRow(item) {
      const currentStageID =
        item?.CurrentStageID !== undefined && item?.CurrentStageID !== null
          ? Number(item.CurrentStageID)
          : 5;
      const cprStatus =
        item?.CprStatus !== undefined && item?.CprStatus !== null
          ? Number(item.CprStatus)
          : 1;

      return {
        ...item,
        CurrentStageID: currentStageID,
        CprStatus: cprStatus,
        CurrentStageName:
          item?.CurrentStageName ||
          (currentStageID === 5 ? "Entrevista Jefe Área" : "-"),
        CprStatusName:
          item?.CprStatusName ||
          (cprStatus === 1 ? "Activo" : cprStatus === 0 ? "Rechazado" : "-"),
      };
    },
    isOwnerOrAdmin(item) {
      return (
        Number(item.PstResponsibleID || 0) ===
        Number(this.$fun.getUserInfo().CtrContract?.PstID || 0)
      );
    },
    canOperateCandidate(item) {
      return (
        Number(item?.CurrentStageID) === 5 && Number(item?.CprStatus) === 1
      );
    },
    patchCandidateState(cprID, patch) {
      const idx = this.candidates.findIndex((c) => c.CprID === cprID);
      if (idx === -1) return;
      this.$set(this.candidates, idx, {
        ...this.candidates[idx],
        ...patch,
      });
    },
    stageColor(stageID) {
      const stage = Number(stageID);
      if (stage >= 7) return "teal";
      if (stage === 6) return "indigo";
      if (stage === 5) return "amber darken-2";
      return "blue-grey";
    },
    statusColor(status) {
      const value = Number(status);
      if (value === 1) return "primary";
      if (value === 0) return "error";
      if (value === 2) return "success";
      return "grey";
    },
    async loadCandidates() {
      this.loadingCandidates = true;
      try {
        const PstResponsibleID =
          this.$fun.getUserInfo().CtrContract?.PstID || 0;
        const IsAdmin = this.$fun.isAdmin();
        const requestID = this.$fun.getUserID();

        if (!IsAdmin && !PstResponsibleID) {
          this.candidates = [];
          this.totalCandidates = 0;
          this.showSnackbar(
            "No se encontró PstID del contrato",
            "warning",
            "mdi-alert",
          );
          return;
        }

        const response = await HmnCandidateProcessService.bossApprovalList(
          PstResponsibleID,
          IsAdmin,
          requestID,
        );
        if (response.data && Array.isArray(response.data)) {
          this.candidates = response.data.map((item) =>
            this.normalizeCandidateRow(item),
          );
          this.totalCandidates = response.data.length;
          this.selectedForAgenda = this.selectedForAgenda.filter((selected) =>
            this.candidates.some(
              (candidate) => candidate.CprID === selected.CprID,
            ),
          );
          console.log("Loaded candidates:", this.candidates);
          console.log("Selected for agenda after load:", this.selectedForAgenda);
          
          const historyResponses = await Promise.all(
            this.candidates.map((candidate) =>
              HmnCandidateProcessService.stageHistory(
                candidate.CprID,
                requestID,
              )
                .then((res) => res?.data || [])
                .catch(() => [])
                .then((history) => ({
                  cprID: candidate.CprID,
                  history,
                })),
            ),
          );

          const agendaMap = {};
          const meetingMap = {};
          historyResponses.forEach(({ cprID, history }) => {
            const flow = this.resolveApprovalFlowFromHistory(history);
            agendaMap[cprID] = flow.hasAgenda;
            meetingMap[cprID] = flow.meeting;
          });
          this.agendaRegistered = agendaMap;
          this.interviewScheduleMap = meetingMap;

          // Autocargar carpeta si viene rprID por query string (ej: desde alerta del jefe)
          const targetRprID = Number(this.$route.query.rprID);
          if (targetRprID > 0 && this.recruitmentFolders && this.recruitmentFolders.length) {
            const folder = this.recruitmentFolders.find(
              (f) => Number(f.RprID) === targetRprID
            );
            if (folder) {
              this.openFolder(folder);
            }
          }
        }
      } catch (error) {
        console.error("Error loading candidates:", error);
        this.showSnackbar(
          "Error al cargar candidatos",
          "error",
          "mdi-alert-circle",
        );
      } finally {
        this.loadingCandidates = false;
      }
    },

    async approveCandidate(candidate) {
      if (!this.canOperateCandidate(candidate)) {
        this.showSnackbar(
          "El candidato no está habilitado para aprobar",
          "warning",
          "mdi-alert",
        );
        return;
      }

      if (!this.hasAgenda(candidate)) {
        this.showSnackbar(
          "Primero registra la agenda/disponibilidad",
          "warning",
          "mdi-alert",
        );
        return;
      }

      if (!this.hasScheduledInterview(candidate)) {
        this.showSnackbar(
          "Primero RRHH debe agendar la reunión en Reclutamiento",
          "warning",
          "mdi-calendar-clock",
        );
        return;
      }

      if (!this.hasInterviewFinished(candidate)) {
        this.showSnackbar(
          "La segunda aceptación se habilita cuando termine la entrevista",
          "warning",
          "mdi-timer-sand",
        );
        return;
      }

      const confirm = await this.$fun.alert(
        `¿Aprobar entrevista de ${candidate.CandidateName}? <br> El candidato avanzará a la siguiente etapa`,
        "question",
      );

      if (!confirm.isConfirmed) return;

      this.approvingCprID = candidate.CprID;
      try {
        const response = await HmnCandidateProcessService.advanceStage(
          candidate.CprID,
          6, // Next stage
          "Aprobado por jefe de área",
          this.$fun.getUserID(),
        );

        if (response) {
          this.patchCandidateState(candidate.CprID, {
            CurrentStageID: 6,
            CurrentStageName: "Evaluación Psicológica",
            CprStatus: 1,
            CprStatusName: "Activo",
          });

          this.showSnackbar(
            `${candidate.CandidateName} aprobado correctamente`,
            "success",
            "mdi-check-circle",
          );
        }
      } catch (error) {
        console.error("Error approving candidate:", error);
        this.showSnackbar(
          "Error al aprobar candidato",
          "error",
          "mdi-alert-circle",
        );
      } finally {
        this.approvingCprID = null;
      }
    },

    async openRejectDialog(candidate) {
      if (!this.canOperateCandidate(candidate)) {
        this.showSnackbar(
          "El candidato no está habilitado para rechazo en esta etapa",
          "warning",
          "mdi-alert",
        );
        return;
      }

      const response = await this.$fun.alert(
        `¿Rechazar a ${candidate.CandidateName}? <br> El candidato no avanzará en el proceso`,
        "question",
      );
      if (response.isConfirmed) {
        this.selectedCandidate = candidate;
        this.rejectObservation = "";
        this.rejectDialog = true;
      }
    },

    async confirmReject() {
      if (!this.rejectObservation.trim()) {
        this.$fun.alert("Debes ingresar una observación", "warning");
        return;
      }

      this.rejectingCprID = this.selectedCandidate.CprID;
      try {
        const response = await HmnCandidateProcessService.updateStatus(
          this.selectedCandidate.CprID,
          0, // Rejected status
          this.rejectObservation,
          this.$fun.getUserID(),
        );

        if (response) {
          this.patchCandidateState(this.selectedCandidate.CprID, {
            CprStatus: 0,
            CprStatusName: "Rechazado",
          });

          this.rejectDialog = false;
          this.showSnackbar(
            `${this.selectedCandidate.CandidateName} rechazado`,
            "warning",
            "mdi-close-circle",
          );
        }
      } catch (error) {
        console.error("Error rejecting candidate:", error);
        this.showSnackbar(
          "Error al rechazar candidato",
          "error",
          "mdi-alert-circle",
        );
      } finally {
        this.rejectingCprID = null;
      }
    },

    async exportToExcel() {
      this.exporting = true;
      try {
        const rprID = this.activeFolderMeta?.RprID;
        const candidateRows = this.filteredCandidates.filter((candidate) =>
          this.activeFolderMeta
            ? Number(candidate.RprID) === Number(this.activeFolderMeta.RprID)
            : true,
        );
        await exportVuetifyToExcel(this.headersExcel, candidateRows, {
          title: "Aprobación de Candidatos",
          subtitle: `Candidatos en entrevista con jefe de área - Generado: ${new Date().toLocaleDateString(
            "es-ES",
          )}`,
          filename: `respuestas-entrevista-rpr-${rprID || reqID}-${Date.now()}`,
          color: "2E7D32",
          minWidth: 12,
          maxWidth: 60,
        });

        this.showSnackbar(
          "Preguntas preliminares exportadas a Excel",
          "success",
          "mdi-file-excel",
        );
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.showSnackbar(
          "Error al exportar a Excel",
          "error",
          "mdi-alert-circle",
        );
      } finally {
        this.exporting = false;
      }
    },

    onPaginationChanged(pagination) {
      this.currentPage = pagination.page;
      this.itemsPerPage = pagination.itemsPerPage;
    },

    detectPreviewType(contentType, fallbackName) {
      const ct = (contentType || "").toLowerCase();
      if (ct.startsWith("image/")) return "image";
      if (ct.indexOf("pdf") !== -1) return "pdf";
      if (fallbackName) {
        const lower = fallbackName.toLowerCase();
        if (lower.endsWith(".pdf")) return "pdf";
        if (lower.match(/\.(jpg|jpeg|png|gif|webp|bmp)$/)) return "image";
      }
      return "other";
    },

    async openCVPreview(item) {
      if (!item || !item.FileKeyCV) return;
      try {
        this.currentPreviewFile = item.FileKeyCV;
        const file = await GenUploadFiles.getFileForPreview(
          "routeCVRecruitment_RRHH",
          item.FileKeyCV,
        );
        if (!file || !file.url) {
          this.showSnackbar(
            "No se pudo cargar el CV",
            "error",
            "mdi-alert-circle",
          );
          return;
        }
        this.previewUrl = file.url;
        this.previewType = this.detectPreviewType(
          file.contentType,
          item.FileKeyCV,
        );
        this.previewDialog = true;
      } catch (error) {
        this.showSnackbar(
          "No se pudo previsualizar el CV",
          "error",
          "mdi-alert-circle",
        );
      }
    },

    downloadCurrentCV() {
      if (!this.currentPreviewFile) return;
      GenUploadFiles.getFile(
        "routeCVRecruitment_RRHH",
        this.currentPreviewFile,
      );
    },

    closePreview() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
      }
      this.previewDialog = false;
      this.previewUrl = null;
      this.previewType = null;
      this.currentPreviewFile = null;
    },

    formatCurrency(value) {
      if (!value) return "S/ 0.00";
      return new Intl.NumberFormat("es-PE", {
        style: "currency",
        currency: "PEN",
      }).format(value);
    },

    getAgeColor(age) {
      if (age < 25) return "blue";
      if (age < 35) return "green";
      if (age < 50) return "orange";
      return "red";
    },

    showSnackbar(message, color = "success", icon = "mdi-check-circle") {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbarIcon = icon;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped lang="scss">
.boss-approval-scrud {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  min-height: 100vh;
  padding-bottom: 40px;

  .approval-hero {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .hero-content {
      display: flex;
      align-items: center;
      max-width: 600px;

      .hero-title {
        font-size: 32px;
        font-weight: 600;
        margin: 0;
      }

      .hero-subtitle {
        font-size: 14px;
        opacity: 0.9;
        margin: 5px 0 0 0;
      }
    }
  }

  .toolbar-section {
    display: flex;
    align-items: center;
    gap: 10px;

    .search-input {
      width: 100%;
    }
  }

  .candidate-name {
    display: flex;
    align-items: center;
  }

  .salary-cell {
    font-weight: 600;
    color: #1976d2;
  }

  .action-buttons {
    display: flex;
    gap: 5px;
    justify-content: center;
  }
}

.boss-toolbar-card {
  border-radius: 14px;
  border-color: #dfe7f1 !important;
  background: #ffffff;
}

.boss-view-toggle {
  border: 1px solid #dbe5f0;
  border-radius: 10px;
}

.folder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 14px;
}

.folder-card {
  border-radius: 14px;
  border-color: #dde6f2 !important;
  cursor: pointer;
  transition: transform 0.16s ease, box-shadow 0.16s ease;
}

.folder-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.folder-card__head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 14px 10px;
}

.folder-card__icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #eef4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.folder-card__title-wrap {
  flex: 1;
  min-width: 0;
}

.folder-card__title {
  margin: 0;
  font-size: 0.97rem;
  font-weight: 700;
  color: #1f2937;
}

.folder-card__subtitle {
  margin: 4px 0 0;
  font-size: 0.78rem;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.folder-card__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 0 14px 10px;
}

.folder-card__stats div {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px;
  text-align: center;
}

.folder-card__stats span {
  display: block;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.folder-card__stats strong {
  display: block;
  font-size: 1rem;
  color: #0f172a;
}

.folder-card__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  border-top: 1px solid #edf2f7;
  padding: 10px 14px;
  color: #475569;
  font-size: 0.76rem;
}

.folder-modal__title {
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .approval-hero {
    flex-direction: column;
    text-align: center;
    gap: 20px;

    .hero-content {
      justify-content: center;
    }
  }
}
@import url("https://fonts.googleapis.com/css2?family=Fraunces:wght@600&family=Manrope:wght@400;600;700&display=swap");

.rpr-page {
  --ink: #1e293b;
  --muted: #64748b;
  --accent: #b45309;
  --accent-soft: #fff7ed;
  --surface: #ffffff;
  --surface-soft: #f8fafc;
  --border: #e2e8f0;
  --shadow-soft: 0 8px 28px rgba(15, 23, 42, 0.07);
  --shadow-card: 0 12px 32px rgba(15, 23, 42, 0.08);
  background: radial-gradient(
      1100px 500px at 0% -10%,
      #ffedd5 0%,
      rgba(255, 237, 213, 0) 60%
    ),
    radial-gradient(
      900px 420px at 100% -5%,
      #dbeafe 0%,
      rgba(219, 234, 254, 0) 58%
    ),
    linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: calc(100vh - 75px);
  padding: 28px;
  padding-bottom: 56px;
  font-family: "Manrope", sans-serif;
  color: var(--ink);
  box-sizing: border-box;
}

.rpr-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  background: linear-gradient(125deg, #0f172a 0%, #1e293b 55%, #334155 100%);
  color: #f8fafc;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: var(--shadow-soft);
  padding: 24px 28px;
}

.rpr-hero__kicker {
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.7rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.75);
}

.rpr-hero__title {
  font-family: "Fraunces", serif;
  font-size: clamp(1.5rem, 2.4vw, 2rem);
  line-height: 1.15;
  margin: 8px 0 6px;
}

.rpr-hero__subtitle {
  margin: 0;
  max-width: 560px;
  color: rgba(248, 250, 252, 0.82);
}

.rpr-hero__badge {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.24);
  backdrop-filter: blur(2px);
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}
</style>
